// #3366FF - azulito
const LIGHT_THEME = {
    BODY: '#FFF',
    BODY_FADE: '#F6F6F6',
    PRIMARY_TEXT_1: '#162D3D',
    PRIMARY_TEXT_2: '#5b6e80',
    INVERTED_TEXT: '#FFFFFF',
    MAIN_COLOR: "#0062ff", //FF0066
    NAV_BG: 'rgba(255,255,255,.2)',
    TAB_BG: 'rgba(0,0,0,.1)',
    CARD_TOOL_BG: '#FFFFFF'
}

const DARK_THEME = { 
    BODY: '#121212', //01161e,
    BODY_FADE: '#000000',
    PRIMARY_TEXT_1: '#FFFFFF',
    PRIMARY_TEXT_2: '#7A92A5',
    INVERTED_TEXT: '#162D3D',
    MAIN_COLOR: "#3366FF",
    NAV_BG: 'rgba(0,0,0,.2)',
    TAB_BG: 'hsla(0,0%,100%,.11)',
    CARD_TOOL_BG: 'hsla(0,0%,100%,.11)',
}

const theme = mode => (mode === "dark" ? DARK_THEME : LIGHT_THEME);

export default theme;